import { createRoot } from 'react-dom/client';
import { mountBlogArticlePage } from '../components/BlogArticlePage.tsx';
import '../../assets/stylesheets/application.tailwind.css';
import '../i18n/config';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('blog-article-page');
  if (!container) return;
  const tree = mountBlogArticlePage(container);
  if (!tree) return;
  const root = createRoot(container);
  root.render(tree);
});
